import React from "react";
import * as PropTypes from "prop-types";
import styled from "styled-components";
import {FullWidthContainer, GlobalStyle, MaxWidthContainer} from "../style/itf-styled-components";
import Header from "../components/header/header";
import Footer from "../components/footer";
import {CookiesProvider} from "react-cookie";
import CookiesConsent from "../components/cookies-consent";

import "../style/reset.css"
import "../style/typography.css"

const Container = styled(FullWidthContainer)`
  background-color: ${props => props.theme.background()};
  color: ${props => props.theme.colors.neutrals.textDefault};
`;

const Content = styled.div`
  display: grid;
  grid-template-columns: repeat(${props => props.children.length}, 1fr);
  
  @media (max-width: 768px) {
    width: 100%;
    display: flex;
    flex-direction: column;
  }
`;

const ColumnsLayout = ({ page, withCookiesConsent, children }) => (
  <>
    <GlobalStyle/>
    <Container>
      <Header page={page}/>
      <MaxWidthContainer>
          <Content>
              {React.Children.map(children, (child) => <>{child}</>)}
          </Content>
      </MaxWidthContainer>
      <Footer/>

      {withCookiesConsent && (
        <CookiesProvider>
          <CookiesConsent/>
        </CookiesProvider>
      )}
    </Container>
  </>
);

ColumnsLayout.defaultProps = {
  withCookiesConsent: true,
};

ColumnsLayout.propTypes = {
  page: PropTypes.string.isRequired,
  withCookiesConsent: PropTypes.bool,
};

export default ColumnsLayout;